import { api } from '../../../api-helper';
import { URLS } from '../../../../constants/URLS';

export const getDocumentType = () => {
  return api.get(URLS.documentType, {
    headers: {
      needsToken: true
    }
  });
};

export const getOpenLienType = () => {
  return api.get(URLS.openLienType, {
    headers: {
      needsToken: true
    }
  });
};

export const getMiscsType = () => {
  return api.get(URLS.miscsType, {
    headers: {
      needsToken: true
    }
  });
};

export const getLeaseType = () => {
  return api.get(URLS.leaseType, {
    headers: {
      needsToken: true
    }
  });
};

export const getOpenMortgageType = () => {
  return api.get(URLS.openMortgageType, {
    headers: {
      needsToken: true
    }
  });
};

export const toggleBookmarkStatus = (name, isBookmarked) => {
  return api.put(
    URLS.toggleBookmarkStatus,
    {
      name: name,
      bookmark: isBookmarked
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const toggleBookmarkStatusOpenLien = (name, isBookmarked) => {
  return api.put(
    URLS.toogleBookmarkStatusOpenLien,
    {
      name: name,
      bookmark: isBookmarked
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const toggleBookmarkStatusMiscs = (name, isBookmarked) => {
  return api.put(
    URLS.toogleBookmarkStatusMiscs,
    {
      name: name,
      bookmark: isBookmarked
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const toggleBookmarkStatusLease = (name, isBookmarked) => {
  return api.put(
    URLS.toogleBookmarkStatusLease,
    {
      name: name,
      bookmark: isBookmarked
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const toggleBookmarkStatusOpenMortgage = (name, isBookmarked) => {
  return api.put(
    URLS.toogleBookmarkStatusOpenMortgage,
    {
      name: name,
      bookmark: isBookmarked
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const saveOrderSearch = (searchPayload) => {
  return api.post(`${URLS.orderSearchSection}`, searchPayload, {
    headers: {
      needsToken: true
    }
  });
};

export const updateOrderSearch = (searchPayload) => {
  return api.put(`${URLS.orderSearchSection}`, searchPayload, {
    headers: {
      needsToken: true
    }
  });
};
